export default [
    'Bonus',
    'Leasing',
    'Management',
    'Other'
];